const routes = [
  {
    path: '/wuhou/1',
    name: 'wuhou1',
    meta: {
      title: '产业领军人才奖励实施细则政策解读与引导'
    },
    component: () => import('./1.vue')
  },
  {
    path: '/wuhou/2',
    name: 'wuhou2',
    meta: {
      title: '产业优秀人才奖励实施细则政策解读与引导'
    },
    component: () => import('./2.vue')
  },
  {
    path: '/wuhou/3',
    name: 'wuhou3',
    meta: {
      title: '鼓励引进培育博士后人才实施细则政策解读与引导'
    },
    component: () => import('./3.vue')
  },
  {
    path: '/wuhou/4',
    name: 'wuhou4',
    meta: {
      title: '科技创新人才和平台奖励政策实施细则解读与引导'
    },
    component: () => import('./4.vue')
  },
  {
    path: '/wuhou/5',
    name: 'wuhou5',
    meta: {
      title: '猎头机构引才奖励实施细则政策解读与引导'
    },
    component: () => import('./5.vue')
  },
  {
    path: '/wuhou/6',
    name: 'wuhou6',
    meta: {
      title: '“名师优师工程”名优教师引进激励政策解读与引导'
    },
    component: () => import('./6.vue')
  },
  {
    path: '/wuhou/7',
    name: 'wuhou7',
    meta: {
      title: '培养引进两院院士和国家级科技领军人才奖励实施细则政策解读与引导'
    },
    component: () => import('./7.vue')
  },
  {
    path: '/wuhou/8',
    name: 'wuhou8',
    meta: {
      title: '青年人才引育实施细则政策解读与引导'
    },
    component: () => import('./8.vue')
  },
  {
    path: '/wuhou/9',
    name: 'wuhou9',
    meta: {
      title: '人才开发券实施细则政策解读与引导'
    },
    component: () => import('./9.vue')
  },
  {
    path: '/wuhou/10',
    name: 'wuhou10',
    meta: {
      title: '新认定院士（专家）创新工作站资助实施细则解读与引导'
    },
    component: () => import('./10.vue')
  },
  {
    path: '/wuhou/11',
    name: 'wuhou11',
    meta: {
      title: '专业技术人才奖励实施细则政策解读与引导'
    },
    component: () => import('./11.vue')
  },
]

export default routes